import { CoreDrawer } from "@/components/common/CoreDrawer";
import UploadNewSection from "@/components/knowledge-base/UploadNewSection";
import type { AddKnowledgeSheetProps } from "@/types/knowledge/knowledge-acquisition";

const AddKnowledgeSheet = ({
  isOpen,
  onClose,
  sessionKey,
  initialMethod = "pdf",
  defaultAgentId = "none",
  availableAgents = [],
  initialTitle,
  onUploadSuccess,
}: AddKnowledgeSheetProps) => (
  <CoreDrawer
    isOpen={isOpen}
    onClose={onClose}
    title="Add knowledge"
    description="Choose where the knowledge lives now, then decide whether to attach it to a Genie straight away."
    className="bg-[#F9FAFC]"
  >
    <div className="py-6">
      <UploadNewSection
        key={`${sessionKey}-${initialMethod}-${defaultAgentId}`}
        initialMethod={initialMethod}
        defaultAgentId={defaultAgentId}
        availableAgents={availableAgents}
        initialTitle={initialTitle}
        onUploadSuccess={onUploadSuccess ?? onClose}
      />
    </div>
  </CoreDrawer>
);

export default AddKnowledgeSheet;
